/**
 * Environment-based logging utility
 * Automatically disables console logs in production builds
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const isTest = process.env.NODE_ENV === 'test';

// Only log in development or test environments
const shouldLog = isDevelopment || isTest;

export const logger = {
  /**
   * Standard logging for general information
   */
  log: (...args: any[]) => {
    if (shouldLog) {
      console.log(...args);
    }
  },

  /**
   * Error logging - always enabled but can be filtered
   */
  error: (...args: any[]) => {
    if (shouldLog) {
      console.error(...args);
    }
  },

  /**
   * Warning logging for potential issues
   */
  warn: (...args: any[]) => {
    if (shouldLog) {
      console.warn(...args);
    }
  },

  /**
   * Info logging for informational messages
   */
  info: (...args: any[]) => {
    if (shouldLog) {
      console.info(...args);
    }
  },

  /**
   * Debug logging for detailed debugging information
   */
  debug: (...args: any[]) => {
    if (shouldLog) {
      console.debug(...args);
    }
  },

  /**
   * Group logging for organizing related log messages
   */
  group: (label: string) => {
    if (shouldLog) {
      console.group(label);
    }
  },

  /**
   * End group logging
   */
  groupEnd: () => {
    if (shouldLog) {
      console.groupEnd();
    }
  },

  /**
   * Table logging for structured data
   */
  table: (data: any) => {
    if (shouldLog) {
      console.table(data);
    }
  },

  /**
   * Performance timing start
   */
  time: (label: string) => {
    if (shouldLog) {
      console.time(label);
    }
  },

  /**
   * Performance timing end
   */
  timeEnd: (label: string) => {
    if (shouldLog) {
      console.timeEnd(label);
    }
  }
};

// Export environment check for conditional logic
export const isProductionBuild = !shouldLog;
export const isDev = isDevelopment;